import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import {
  get_payment_summary,
  Get_Plans,
  Start_Check_Out,
} from "../../slices/thunks";
import { set_bread_crum } from '../../slices/header/reducer';
import Loader from "../../Components/Common/Loader";
import { waitForDecision } from "../../utility/wait_for_confirmation";
import {
  close_confirm_modal,
  open_confirm_modal,
} from "../../slices/Confirm_Modal/reducer";

const PricingTable = () => {
  const [isMonthly, setIsMonthly] = useState(true);

  const dispatch = useDispatch();
  const { plans, loading } = useSelector((state) => state.Plans);

  const { Plan_Id } = useSelector((state) => state.Plans.current_plan_details);

  useEffect(() => {
    dispatch(Get_Plans());
    dispatch(get_payment_summary());
  }, []);

  // Change data structure for Model wise token rendering ,

  const Generate_data_for_model_wise_token_rendering = ({
    model_tokens,
    token_packages,
  }) => {
    // List out the token .
    let models = [];
    token_packages.forEach((element) => {
      models.push(element.model_version);
    });

    models = [...new Set(models)];

    // make model wise package and Add on .
    let model_wise_package = [];
    models.forEach((model) => {
      let temp_pak = {
        model_name: model,
        tokens_available_with_plan: "",
        Add_on_plans: [],
      };
      model_tokens.forEach((element) => {
        if (element.model_version == model) {
          temp_pak.tokens_available_with_plan = element.free_tokens;
        }
      });

      token_packages.forEach((_package) => {
        if (_package.model_version == model) {
          temp_pak.Add_on_plans.push({
            price: _package.price,
            tokens: _package.tokens,
          });
        }
      });

      model_wise_package.push(temp_pak);
    });

    return model_wise_package;
  };
  useEffect(()=>{
    dispatch(set_bread_crum({ title:"Pricing"  , pageTitle:"Dashboard"  }))

    return ()=>{
    dispatch(set_bread_crum({ title:""  , pageTitle:""  }))
       
    }
  },[])
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="justify-content-center">
            <Col xl={12}>
              <div className="d-flex justify-content-between mb-30">
                <h2 className="">Subscription Plans</h2>
                <div className="switch-container">
                  <div
                    className={`switch-toggle ${
                      isMonthly ? "monthly" : "yearly"
                    }`}
                    onClick={() => setIsMonthly(!isMonthly)}
                  >
                    <div className="switch-slider bg-secondary"></div>
                    <span
                      className={`switch-option ${isMonthly ? "active" : ""}`}
                    >
                      Monthly
                    </span>
                    <span
                      className={`switch-option ${!isMonthly ? "active" : ""}`}
                    >
                      Yearly
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col xl={12}>
                  <div className="otsf">
                    <h2>One-Time Setup Fee</h2>
                    <p>Let us handle the setup! Pay once and get your work environment ready hassle-free. <a href="mailto:mailto:info@dbinsight.ai">{'[Contact us]'}</a></p>
                  </div>
                </Col>
            {loading ? (
              <Loader />
            ) : (
              <Col xl={12} className="price_wrap">
                <Row>
                  {plans.map((plan) => {
                    const {
                      monthly_fee,
                      plan_id,
                      plan_name,
                      yearly_fee,
                      model_features,
                      model_tokens,
                      token_packages,
                      features,
                      FreeTokens,
                    } = plan;
                    let model_wise_packages_details =
                      Generate_data_for_model_wise_token_rendering({
                        token_packages,
                        model_tokens,
                      });

                    // console.log(model_wise_packages_details);

                    return (
                      <Col lg={3} sm={6} xs={12}>
                        <Card
                          className={`pricing-box ribbon-box ${
                            Plan_Id === plan_id && "bg-dark-subtle"
                          }  `}
                        >
                          <CardBody className="p-4 m-2">
                            <div className="d-flex align-items-center">
                              <div className="flex-grow-1">
                                <h5 className="mb-1 fw-semibold">
                                  {plan_name}
                                </h5>
                              </div>
                              <div className="cp">
                                {Plan_Id === plan_id && "Current Plan"}
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="pt-4">
                                <h2>
                                  <sup>
                                    <small>US$ </small>
                                  </sup>
                                  {isMonthly ? monthly_fee : yearly_fee}
                                  <span className="fs-13 text-muted">
                                    {isMonthly ? "/Month" : "/Year"}
                                  </span>
                                </h2>
                              </div>
                            </div>
                            {/* {plan_id !== Plan_Id ? (
                              <>
                                {plan_id > Plan_Id || !Plan_Id ? (
                                  <div
                                    onClick={async () => {
                                      dispatch(
                                        open_confirm_modal(
                                          "Are you sure you want to buy this plan."
                                        )
                                      );
                                      const decision = await waitForDecision();
                                      if (decision) {
                                        dispatch(
                                          Start_Check_Out({
                                            plan_id: plan_id,
                                            plan_type: !isMonthly
                                              ? "yearly"
                                              : "monthly",
                                          })
                                        );
                                      }
                                      dispatch(close_confirm_modal());
                                    }}
                                    className="mt-4"
                                  >
                                    <Link
                                      to="#"
                                      className="btn btn-secondary w-100 waves-effect waves-light"
                                    >
                                      {Plan_Id ? "Upgrade Plan" : "Choose Plan"}
                                    </Link>
                                  </div>
                                ) : (
                                  <div
                                    onClick={async () => {
                                      dispatch(
                                        open_confirm_modal(
                                          "Are you sure you want to buy this plan."
                                        )
                                      );
                                      const decision = await waitForDecision();
                                      if (decision) {
                                        dispatch(
                                          Start_Check_Out({
                                            plan_id: plan_id,
                                            plan_type: !isMonthly
                                              ? "yearly"
                                              : "monthly",
                                          })
                                        );
                                      }
                                      dispatch(close_confirm_modal());
                                      // dispatch(Start_Check_Out({ plan_id:plan_id , plan_type:!isMonthly ? 'yearly':'monthly' }))
                                    }}
                                    className="mt-4"
                                  >
                                    <Link
                                      to="#"
                                      className="btn btn-danger w-100 waves-effect waves-light"
                                    >
                                      {Plan_Id
                                        ? "Downgrade Plan"
                                        : "Choose Plan"}
                                    </Link>
                                  </div>
                                )
                                
                                
                                
                                }
                              </>
                            ):
                            <div
                            style={{
                                visibility:"hidden"
                            }}
                            onClick={async () => {
                              dispatch(
                                open_confirm_modal(
                                  "Are you sure you want to buy this plan."
                                )
                              );
                              const decision = await waitForDecision();
                              if (decision) {
                                dispatch(
                                  Start_Check_Out({
                                    plan_id: plan_id,
                                    plan_type: !isMonthly
                                      ? "yearly"
                                      : "monthly",
                                  })
                                );
                              }
                              dispatch(close_confirm_modal());
                            }}
                            className="mt-4"
                          >
                            <Link
                              to="#"
                              className="btn btn-secondary w-100 waves-effect waves-light"
                            >
                              {Plan_Id ? "Upgrade Plan" : "Choose Plan"}
                            </Link>
                          </div>
                            } */}
                            {plan_id !== Plan_Id ? (
                                  <>
                                    {plan_id > Plan_Id || !Plan_Id ? (
                                      <div
                                        onClick={async () => {
                                          dispatch(
                                            open_confirm_modal(
                                              "Are you sure you want to buy this plan."
                                            )
                                          );
                                          const decision = await waitForDecision();
                                          if (decision) {
                                            dispatch(
                                              Start_Check_Out({
                                                plan_id: plan_id,
                                                plan_type: !isMonthly ? "yearly" : "monthly",
                                              })
                                            );
                                          }
                                          dispatch(close_confirm_modal());
                                        }}
                                        className="mt-4"
                                      >
                                        <Link
                                          to="#"
                                          className="btn btn-secondary w-100 waves-effect waves-light"
                                        >
                                          {Plan_Id ? "Upgrade Plan" : "Choose Plan"}
                                        </Link>
                                      </div>
                                    ) : (
                                      <div
                                        onClick={async () => {
                                          dispatch(
                                            open_confirm_modal(
                                              "Are you sure you want to buy this plan."
                                            )
                                          );
                                          const decision = await waitForDecision();
                                          if (decision) {
                                            dispatch(
                                              Start_Check_Out({
                                                plan_id: plan_id,
                                                plan_type: !isMonthly ? "yearly" : "monthly",
                                              })
                                            );
                                          }
                                          dispatch(close_confirm_modal());
                                        }}
                                        className="mt-4"
                                      >
                                        <Link
                                          to="#"
                                          className="btn btn-danger w-100 waves-effect waves-light"
                                        >
                                          {Plan_Id ? "Downgrade Plan" : "Choose Plan"}
                                        </Link>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <div className="mt-4">
                                    <Link
                                      to="#"
                                      className="btn btn-light custom-light w-100 waves-effect waves-light"
                                      disabled
                                      style={{backgroundColor:'#ced4da'}}
                                    >
                                      Current Plan
                                    </Link>
                                  </div>
                                )}
                                <hr className="my-4 text-muted" />
                                <div className="d-flex">
                                  <div className="flex-shrink-0 text-success me-1">
                                    <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                  </div>
                                  <div className="flex-grow-1">
                                    <b>{"Free Token"} :</b>{" "}
                                    {FreeTokens.toLocaleString()} tokens / month <i className="ri-asterisk text-secondary" style={{fontSize:'10px'}}></i>
                                  </div>
                                </div>
                                {/* <hr className="my-4 text-muted" />
                            <h5 className="">
                              <b>Other Features</b>
                            </h5> */}
                            <hr className="my-4 text-muted" />
                            <div className="min-h">
                              <ul className="list-unstyled text-muted vstack gap-3">
                                {features.map((feature) => {
                                  const { feature_name, value } = feature;
                                  <li>
                                  <div className="d-flex">
                                    <div className="flex-shrink-0 text-info me-1">
                                      <i className="ri-radio-button-line fs-15 align-middle"></i>
                                    </div>
                                    <div className="flex-grow-1">
                                      <b>{'LLM models: Limited'} :</b> {plan_id==1?'Limited':'Available list'}
                                    </div>
                                  </div>
                                </li>
                                  return (
                                    <li>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 text-info me-1">
                                          <i className="ri-radio-button-line fs-15 align-middle"></i>
                                        </div>
                                        <div className="flex-grow-1">
                                          <b>{feature_name} :</b> {value}
                                        </div>
                                      </div>
                                    </li>
                                  );
                                })}
                                {/* <li>
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 text-success me-1">
                                                    <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                <b>No. of bots :</b> Unlimited
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 text-success me-1">
                                                    <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                <b>DB Connections per Group :</b> 1
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 text-success me-1">
                                                    <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                <b>Max Tables per Bot :</b> 1
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 text-success me-1">
                                                    <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                <b>Users per Group :</b> 1
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 text-danger me-1">
                                                    <i className="ri-close-circle-fill fs-15 align-middle-circle-fill fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                <b>Extra users in group :</b> Not Available
                                                </div>
                                            </div>
                                        </li> */}
                              </ul>
                            </div>

                            <hr className="my-4 text-muted" />
                            <h5 className="">
                              <b>Knowledge upload</b>
                            </h5>
                            <hr className="my-4 text-muted" />
                            <div>
                              <ul className="list-unstyled text-muted vstack gap-3">
                                {model_features.map((feature) => {
                                  const {
                                    is_free,
                                    is_token_applicable,
                                    model_feature_id,
                                    model_feature_name,
                                  } = feature;

                                  return (
                                    <li>
                                      <div className="d-flex">
                                        {!is_free ? (
                                          <div className="flex-shrink-0 text-danger me-1">
                                            <i className="ri-close-circle-fill fs-15 align-middle-circle-fill fs-15 align-middle"></i>
                                          </div>
                                        ) : (
                                          <div className="flex-shrink-0 text-success me-1">
                                            <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                          </div>
                                        )}
                                        <div className="flex-grow-1">
                                          <b>{model_feature_name} </b>{" "}
                                          {/* {is_free ? "FREE" : "Not Available"} */}
                                        </div>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>

                            {/* <hr className="my-4 text-muted" />
                                <h5 className=''><b>Available Tokens</b></h5>
                                <hr className="my-4 text-muted" /> */}
                            {/* <div>
                                    <ul className="list-unstyled text-muted vstack gap-3">
                                        {
                                            model_tokens.map((token)=>{
                                                const { free_tokens , model_version } = token
                                                return     <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        {free_tokens} tokens per month for {model_version}
                                                    </div>
                                                </div>
                                            </li>
                                            })
                                        }
                                       
                                        
                                    </ul>                                        
                                </div> */}
                            {/* <hr className="my-4 text-muted" />
                                <h5 className=''><b>Add-ons</b></h5>
                                <hr className="my-4 text-muted" /> */}
                            {/* 
                                <hr className="my-4 text-muted" />
                                <h5 className=''><b>Add-ons</b></h5>
                                <hr className="my-4 text-muted" /> */}
                            <div>
                              <div className="addons_ac_modal">
                                {model_wise_packages_details.map(
                                  (package_details) => {
                                    const {
                                      model_name,
                                      tokens_available_with_plan,
                                      Add_on_plans,
                                    } = package_details;
                                    return (
                                      <>
                                        <p>
                                          {/* <b>{model_name}</b> */}

                                          <hr className="my-4 text-muted" />
                                          <h5 className="">
                                            <b>{model_name}</b>
                                          </h5>
                                          {/* <hr className="my-4 text-muted" /> */}
                                          <div></div>
                                        </p>
                                        <ul className="list-unstyled text-muted vstack gap-3">
                                          {/* <li>
                                            <div className="d-flex">
                                              <div className="flex-shrink-0 text-success me-1">
                                                <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                              </div>
                                              <div className="flex-grow-1">
                                                <b>{"Free Token"} :</b>{" "}
                                                {FreeTokens.toLocaleString()} tokens / month <i className="ri-asterisk text-secondary" style={{fontSize:'10px'}}></i>
                                              </div>
                                            </div>
                                          </li> */}
                                         <h5 className="">{"Token Add-on"}</h5>
                                          {token_packages.map((_package) => {
                                            const { PackageTokens, Price } =
                                              _package;

                                            return (
                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-add-circle-fill fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>${Price} :</b>{" "}
                                                    {PackageTokens.toLocaleString()} tokens
                                                  </div>
                                                </div>
                                              </li>
                                            );
                                          })}
                                        </ul>
                                        <p> <i className="ri-asterisk text-secondary" style={{fontSize:'10px'}}></i><span style={{color:'red',fontSize:'10px'}}>"The token balance will expire at the end of each payment cycle."</span></p>
                                      </>
                                    );
                                  }
                                )}
                                {/* <p><b>GPT 3.5</b></p>
                                        <ul className="list-unstyled text-muted vstack gap-3" style={{padding : "0px 0px 0px 15px"}}>
                                        {
                                            token_packages.map((_package)=>{
                                                const {tokens,price} = _package
                                                return  <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                    <b>${price} :</b> {tokens} tokens

                                                    </div>
                                                </div>
                                            </li>
                                            })
                                        }
                                   
                                    </ul> */}

                                {/* <p><b>GPT 4</b></p>
                                        <ul className="list-unstyled text-muted vstack gap-3" style={{padding : "0px 0px 0px 15px"}}>
                                        {
                                            token_packages.map((_package)=>{
                                                const {tokens,price} = _package
                                                return  <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                    <b>${price} :</b> {tokens} tokens

                                                    </div>
                                                </div>
                                            </li>
                                            })
                                        }
                                   
                                    </ul> */}
                              </div>
                              {/* <ul className="list-unstyled text-muted vstack gap-3">
                                        {
                                            token_packages.map((_package)=>{
                                                const {tokens,price} = _package
                                                return  <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                    <b>${price} :</b> {tokens} tokens

                                                    </div>
                                                </div>
                                            </li>
                                            })
                                        }
                                   
                                    </ul>                                         */}
                            </div>
                            
                            <hr className="my-4 text-muted" />
                            <h5 className="">
                              <b>Support</b>
                            </h5>
                            <hr className="my-4 text-muted" />
                            <div className="d-flex">                              
                              <div className="flex-grow-1 text-muted">
                              {(plan_name === "Free" || plan_name === "Basic") && (<p>Email Support</p>)}
                              {(plan_name === "Standard" || plan_name === "Pro") && (<p>Email & Chat Support</p>)}
                              </div>
                            </div>
                            {/* <div onClick={()=>{
                                     dispatch(Start_Check_Out({ plan_id:plan_id , plan_type:'monthly' }))
                                }} className="mt-4">
                                        <Link 
                                
                                         to="#" className="btn btn-primary w-100 waves-effect waves-light">Take Monthly</Link>
                                    </div>
                                    <div onClick={()=>{
                                     dispatch(Start_Check_Out({ plan_id:plan_id , plan_type:'yearly' }))
                                }} className="mt-4">
                                        <Link 
                                        
                                         to="#" className="btn btn-primary w-100 waves-effect waves-light">Take Yearly</Link>
                                    </div> */}

                            {/* {plan_id !== Plan_Id ? (
                              <>
                                {plan_id > Plan_Id || !Plan_Id ? (
                                  <div
                                    onClick={async () => {
                                      dispatch(
                                        open_confirm_modal(
                                          "Are you sure you want to buy this plan."
                                        )
                                      );
                                      const decision = await waitForDecision();
                                      if (decision) {
                                        dispatch(
                                          Start_Check_Out({
                                            plan_id: plan_id,
                                            plan_type: !isMonthly
                                              ? "yearly"
                                              : "monthly",
                                          })
                                        );
                                      }
                                      dispatch(close_confirm_modal());
                                    }}
                                    className="mt-4"
                                  >
                                    <Link
                                      to="#"
                                      className="btn btn-secondary w-100 waves-effect waves-light"
                                    >
                                      {Plan_Id ? "Upgrade Plan" : "Choose Plan"}
                                    </Link>
                                  </div>
                                ) : (
                                  <div
                                    onClick={async () => {
                                      dispatch(
                                        open_confirm_modal(
                                          "Are you sure you want to buy this plan."
                                        )
                                      );
                                      const decision = await waitForDecision();
                                      if (decision) {
                                        dispatch(
                                          Start_Check_Out({
                                            plan_id: plan_id,
                                            plan_type: !isMonthly
                                              ? "yearly"
                                              : "monthly",
                                          })
                                        );
                                      }
                                      dispatch(close_confirm_modal());
                                      // dispatch(Start_Check_Out({ plan_id:plan_id , plan_type:!isMonthly ? 'yearly':'monthly' }))
                                    }}
                                    className="mt-4"
                                  >
                                    <Link
                                      to="#"
                                      className="btn btn-danger w-100 waves-effect waves-light"
                                    >
                                      {Plan_Id
                                        ? "Downgrade Plan"
                                        : "Choose Plan"}
                                    </Link>
                                  </div>
                                )
                                
                                
                                
                                }
                              </>
                            ):
                            <div
                            style={{
                                visibility:"hidden"
                            }}
                            onClick={async () => {
                              dispatch(
                                open_confirm_modal(
                                  "Are you sure you want to buy this plan."
                                )
                              );
                              const decision = await waitForDecision();
                              if (decision) {
                                dispatch(
                                  Start_Check_Out({
                                    plan_id: plan_id,
                                    plan_type: !isMonthly
                                      ? "yearly"
                                      : "monthly",
                                  })
                                );
                              }
                              dispatch(close_confirm_modal());
                            }}
                            className="mt-4"
                          >
                            <Link
                              to="#"
                              className="btn btn-secondary w-100 waves-effect waves-light"
                            >
                              {Plan_Id ? "Upgrade Plan" : "Choose Plan"}
                            </Link>
                          </div>
                            } */}
                          </CardBody>
                        </Card>
                      </Col>
                    );
                  })}
                  <Col lg={3} sm={6} xs={12}>
                        <Card className="pricing-box ribbon-box">
                          <CardBody className="p-4 m-2">
                            <div className="d-flex align-items-center">
                              <div className="flex-grow-1">
                                <h5 className="mb-1 fw-semibold">
                                  <p>Entreprise</p>
                                </h5>
                              </div>
                              {/* <div className="cp">
                                 <p>Current Plan</p>
                              </div> */}
                            </div>   
                            <div className="mt-4">
                            <a href="mailto:info@dbinsight.ai" className="btn btn-secondary w-100 waves-effect waves-light">
                                Contact us 
                              </a>
                            </div>
                            <hr className="my-4 text-muted" />
                            <div>
                              <ul className="list-unstyled text-muted vstack gap-3">
                                    <li>
                                      <div className="d-flex">
                                        Get exclusive features for your organisation
                                      </div>
                                    </li>
                                    <li>
                                      <div className="d-flex">
                                          You may set up On-Premises LLM privately
                                      </div>
                                    </li>
                                    <li>
                                      <div className="d-flex">
                                        Set up and deployment assistant
                                      </div>
                                    </li>
                              </ul>
                            </div>
                            <hr className="my-4 text-muted" />
                            
                            <div className="fix_bottom">
                              <hr className="my-4 text-muted" />
                              <h5 className="">
                                <b>Support</b>
                              </h5>
                              <hr className="my-4 text-muted" />
                              <div className="d-flex">                              
                                <div className="flex-grow-1 text-muted">
                                    <p>Dedicated support channel for WhatsAPP and email support
                                    {/* <a href="mailto:info@dbinsight.ai" className="text-muted">Email & Chat Support</a> */}
                                    </p>
                                </div>
                              </div>
                            </div>

                          </CardBody>
                        </Card>
                      </Col>
                </Row>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PricingTable;
